import { useContent } from '@/content';

export default function StudioSection() {
  const c = useContent();
  return (
    <section className="py-20 md:py-28 bg-gradient-champagne relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-white/20 blur-3xl"></div>

      <div className="max-w-6xl mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-12 animate-on-scroll">
          <p className="text-xs tracking-[0.3em] uppercase text-champagne-600 font-medium mb-3">
            {c.studio.eyebrow}
          </p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-gray-800 mb-4">
            {c.studio.title}
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            {c.studio.subtitle}
          </p>
        </div>

        {/* Three real studio photos */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {/* Empfangsbereich mit Zertifikaten */}
          <div className="animate-on-scroll delay-100 group">
            <div className="rounded-xl overflow-hidden aspect-[3/4] relative">
              <img
                src="https://static.readdy.ai/image/62e59b4a12706970a459027b4a407756/f8ccf82c0f9b091963903baf7d611867.jpeg"
                alt="Empfangsbereich mit Zertifikaten – Kosmetikstudio Gesichtszauber"
                title="Empfangsbereich – Kosmetikstudio Gesichtszauber Wertingen"
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <p className="text-white text-sm font-medium tracking-wide">{c.studio.caption1}</p>
              </div>
            </div>
          </div>

          {/* WC / Gästebereich */}
          <div className="animate-on-scroll delay-200 group">
            <div className="rounded-xl overflow-hidden aspect-[3/4] relative">
              <img
                src="https://static.readdy.ai/image/62e59b4a12706970a459027b4a407756/72a7202aaab15d3fb2f27931ce2cac11.jpeg"
                alt="Hygiene und Komfort – Kosmetikstudio Gesichtszauber"
                title="Hygiene und Komfort – Kosmetikstudio Gesichtszauber Wertingen"
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <p className="text-white text-sm font-medium tracking-wide">{c.studio.caption2}</p>
              </div>
            </div>
          </div>

          {/* Behandlungsbereich */}
          <div className="animate-on-scroll delay-300 group">
            <div className="rounded-xl overflow-hidden aspect-[3/4] relative">
              <img
                src="https://static.readdy.ai/image/62e59b4a12706970a459027b4a407756/a06764219834da0e1a577ab76a8ddf2c.jpeg"
                alt="Behandlungsbereich – Kosmetikstudio Gesichtszauber"
                title="Behandlungsbereich – Kosmetikstudio Gesichtszauber Wertingen"
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <p className="text-white text-sm font-medium tracking-wide">{c.studio.caption3}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}